import React from "react";
import SexMenu from "./Filters/SexMenu";
import InsuranceMenu from "./Filters/InsuranceMenu";
import AgeMenu from "./Filters/AgeMenu";
import CohortMenu from "./Filters/CohortMenu";
import YearsMenu from "./Filters/YearsMenu";
import StateMenu from "./Filters/StateMenu";

const MobileFilters = ({
  displayValue,
  map,
  comparator,
}: {
  displayValue: number;
  map: boolean;
  comparator: string;
}) => {
  const pathName = window.location.pathname;

  const openSelect = (selectId: string) => {
    const selectElement = document.getElementById(
      selectId,
    ) as HTMLSelectElement;
    if (selectElement) {
      selectElement.focus();
      if (typeof selectElement.showPicker === "function") {
        try {
          selectElement.showPicker();
        } catch (e) {
          console.log("showPicker not supported or failed");
        }
      }
    }
  };

  const allFilters =
    pathName === "/comparator"
      ? [
          {
            key: "Cohort",
            label: "Cohort",
            id: "mobile-cohort-select",
            Component: CohortMenu,
          },
          {
            key: "Age",
            label: "Age",
            id: "mobile-age-select",
            Component: AgeMenu,
          },
          {
            key: "Sex",
            label: "Sex",
            id: "mobile-sex-select",
            Component: SexMenu,
          },
          {
            key: "Insurance",
            label: "Insurance",
            id: "mobile-insurance-select",
            Component: InsuranceMenu,
          },
          {
            key: "State",
            label: "State",
            id: "mobile-state-select",
            Component: StateMenu,
          },
          {
            key: "Year",
            label: "Years",
            id: "mobile-years-select",
            Component: YearsMenu,
          },
        ]
      : [
          {
            key: "Cohort",
            label: "Cohort",
            id: "mobile-cohort-select",
            Component: CohortMenu,
          },
          {
            key: "Age",
            label: "Age",
            id: "mobile-age-select",
            Component: AgeMenu,
          },
          {
            key: "Sex",
            label: "Sex",
            id: "mobile-sex-select",
            Component: SexMenu,
          },
          {
            key: "Insurance",
            label: "Insurance",
            id: "mobile-insurance-select",
            Component: InsuranceMenu,
          },
          {
            key: "State",
            label: "State",
            id: "mobile-state-select",
            Component: StateMenu,
          },
          {
            key: "Year",
            label: "Years",
            id: "mobile-years-select",
            Component: YearsMenu,
          },
        ];

  const availableFilters = allFilters.filter(
    (filter) => filter.key !== comparator,
  );

  const topFilters = availableFilters.slice(0, 3);
  const bottomFilters = availableFilters.slice(3, 6);

  const renderFilter = (filter: (typeof allFilters)[0]) => (
    <div
      className="flex flex-col items-center justify-center h-full"
      key={filter.key}>
      <div className="text-center">
        <label
          onClick={() => openSelect(filter.id)}
          className="flex items-center justify-center gap-2 text-[#2A424B] text-[16px] cursor-pointer">
          {filter.label}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="8"
            height="4"
            viewBox="0 0 8 4"
            fill="none">
            <path
              d="M4.3141 3.87947C4.23076 3.95665 4.11779 4 4 4C3.88221 4 3.76924 3.95665 3.6859 3.87947L0.129992 0.58247C0.0467538 0.505196 0 0.400449 0 0.291235C0 0.182021 0.0467538 0.0772736 0.129992 0H7.87001C7.95325 0.0772736 8 0.182021 8 0.291235C8 0.400449 7.95325 0.505196 7.87001 0.58247L4.3141 3.87947Z"
              fill="#2A424B"
            />
          </svg>
        </label>
        <div
          className={`${filter.label == "Years" ? "w-fit" : "w-fit"} text-center`}>
          <filter.Component displayValue={displayValue} id={filter.id} />
        </div>
      </div>
    </div>
  );

  return (
    <div className="rounded-[8px] bg-[#E5DCDD] border-[#00000033] border w-full">
      <div className="grid grid-cols-3 py-2.5 border-b border-[#00000033]">
        {topFilters.map((filter, index) => (
          <div
            key={filter.key}
            className={index > 0 ? "border-l border-[#00000033]" : ""}>
            {renderFilter(filter)}
          </div>
        ))}
      </div>
      <div
        className={`grid ${
          pathName == "/comparator" ? "grid-cols-2" : "grid-cols-3"
        } py-2.5`}>
        {bottomFilters.map((filter, index) => (
          <div
            key={filter.key}
            className={index > 0 ? "border-l border-[#00000033]" : ""}>
            {renderFilter(filter)}
          </div>
        ))}
      </div>
    </div>
  );
};

export default MobileFilters;